import { render, staticRenderFns } from "./buildRecord.vue?vue&type=template&id=c2ad0b28&scoped=true&"
import script from "./buildRecord.vue?vue&type=script&lang=js&"
export * from "./buildRecord.vue?vue&type=script&lang=js&"
import style0 from "./buildRecord.vue?vue&type=style&index=0&id=c2ad0b28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ad0b28",
  null
  
)

export default component.exports